export const MIN_TOTAL_SECURITY_QUESTIONS_CUSTOM_UI = 2;
export const MIN_TOTAL_SECURITY_QUESTIONS_SDK_UI = 3;
export const MINIMUM_CORRECT_SECURITY_QUESTIONS = 2;

export function getMinimumAllowedCorrectQuestions(totalQuestions) {
  return Math.max(
    MINIMUM_CORRECT_SECURITY_QUESTIONS,
    Math.ceil(Number(totalQuestions) / 2),
  );
}

function isValidSecurityQuestionKNValuesWithMinTotal(
  totalQuestions,
  minimumCorrectQuestions,
  minTotalQuestions,
) {
  const normalizedTotalQuestions = Number(totalQuestions);
  const normalizedMinimumCorrectQuestions = Number(minimumCorrectQuestions);
  const minimumAllowedK = getMinimumAllowedCorrectQuestions(
    normalizedTotalQuestions,
  );

  return (
    normalizedTotalQuestions >= minTotalQuestions &&
    normalizedTotalQuestions <= 10 &&
    normalizedMinimumCorrectQuestions >= MINIMUM_CORRECT_SECURITY_QUESTIONS &&
    normalizedMinimumCorrectQuestions >= minimumAllowedK &&
    normalizedMinimumCorrectQuestions <= normalizedTotalQuestions &&
    normalizedMinimumCorrectQuestions <= 10
  );
}

/** SDK popup UI — minimum 3 total questions. */
export function isValidSecurityQuestionKNValues(
  totalQuestions,
  minimumCorrectQuestions,
) {
  return isValidSecurityQuestionKNValuesWithMinTotal(
    totalQuestions,
    minimumCorrectQuestions,
    MIN_TOTAL_SECURITY_QUESTIONS_SDK_UI,
  );
}

/** Custom UI via setNewUserCredentials — minimum 2 total questions. */
export function isValidCustomSecurityQuestionKNValues(
  totalQuestions,
  minimumCorrectQuestions,
) {
  return isValidSecurityQuestionKNValuesWithMinTotal(
    totalQuestions,
    minimumCorrectQuestions,
    MIN_TOTAL_SECURITY_QUESTIONS_CUSTOM_UI,
  );
}

/**
 * Maps validation-secret payload from twoFA / set-security-questions APIs into the
 * encrypted-part and salt shapes used by decryptUserPrivateKey.
 */
export function mapValidationSecretDataRequestForReauthentication(
  validationSecretDataRequest,
) {
  if (!validationSecretDataRequest?.length) {
    return null;
  }

  return {
    encryptedParts: validationSecretDataRequest.map(
      ({ questionId, encryptedValidationSecretPart }) => ({
        questionId,
        encryptedUserPrivateKeyPart: encryptedValidationSecretPart,
      }),
    ),
    keySalts: validationSecretDataRequest.map(
      ({ questionId, keyValidationSecretSalt }) => ({
        questionId,
        keyAnswerSalt: keyValidationSecretSalt,
      }),
    ),
  };
}
